import { ConversaResumo } from '../types/conversa';
import { renderEmojiWithFallback } from './emojiUtils';
import { DraftManager } from './draftManager';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const getUltimaMensagemComRascunho = (conversa: ConversaResumo): { texto: string; isRascunho: boolean } => {  const draftContent = DraftManager.loadDraft(conversa.id);

  if (draftContent) {
    return { texto: draftContent, isRascunho: true };
  }

  if (conversa.ultimaMensagem?.conteudo) {
    return { texto: conversa.ultimaMensagem.conteudo, isRascunho: false };
  }

  return { texto: '', isRascunho: false };
};

export const mapBackendConversaToResumo = (conversa: any): ConversaResumo => {
  return {
    id: conversa.id,
    remoteJid: conversa.contato?.telefone ? `${conversa.contato.telefone}@s.whatsapp.net` : conversa.remoteJid,
    nome: renderEmojiWithFallback(conversa.contato?.nome || conversa.nome || 'Desconhecido'),
    avatar: conversa.contato?.avatarUrl || conversa.avatarUrl || undefined,
    fixada: conversa.fixada ?? false,
    statusTicket: conversa.status,
    dataAtualizacao: conversa.dataAtualizacao ? new Date(conversa.dataAtualizacao) : (conversa.dataCriacao ? new Date(conversa.dataCriacao) : new Date()),
    ultimaMensagem: conversa.ultimaMensagem
      ? {
        id: conversa.ultimaMensagem.id,
        tipo: conversa.ultimaMensagem.tipo,
        apiMessageId: conversa.ultimaMensagem.apiMessageId,
        evolutionMessageId: conversa.ultimaMensagem.evolutionMessageId,
        conteudo: conversa.ultimaMensagem.conteudo,
        timestamp: new Date(conversa.ultimaMensagem.timestamp),
        statusEntrega: conversa.ultimaMensagem.statusEntrega,
        remetenteTipo: conversa.ultimaMensagem.remetenteTipo,
        isGrupo: conversa.ultimaMensagem.isGrupo,
        remetenteContato: conversa.ultimaMensagem.contato || conversa.ultimaMensagem.remetenteContato ? {
          id: conversa.ultimaMensagem.contato?.id || conversa.ultimaMensagem.remetenteContato?.id,
          nome: conversa.ultimaMensagem.contato?.nome || conversa.ultimaMensagem.remetenteContato?.nome,
          telefone: conversa.ultimaMensagem.contato?.telefone || conversa.ultimaMensagem.remetenteContato?.telefone,
          avatarUrl: conversa.ultimaMensagem.contato?.avatarUrl || conversa.ultimaMensagem.remetenteContato?.avatarUrl
        } : undefined
      }
      : undefined,
    naoLidas: conversa.naoLidas ?? 0,
    contatoId: conversa.contatoId,
    contato: conversa.contato,
    status: conversa.status,
    empresaId: conversa.empresaId,
    atendenteId: conversa.usuarioId,
    atendente: conversa.atendente || conversa.usuario ? {
      id: conversa.atendente?.id || conversa.usuario?.id,
      nome: conversa.atendente?.nome || conversa.usuario?.nome,
      avatarUrl: conversa.atendente?.avatarUrl || conversa.usuario?.avatarUrl
    } : undefined,
    instancia: conversa.instancia || conversa.instanciaEvolution || conversa.instanciaUazapi || conversa.instanciaMeta ? {
      id: conversa.instancia?.id || conversa.instanciaEvolution?.id || conversa.instanciaUazapi?.id || conversa.instanciaMeta?.id,
      nome: conversa.instancia?.nome || conversa.instanciaEvolution?.nome || conversa.instanciaUazapi?.nome || conversa.instanciaMeta?.nome,
      statusConexao: conversa.instancia?.statusConexao || conversa.instanciaEvolution?.statusConexao || conversa.instanciaUazapi?.statusConexao || conversa.instanciaMeta?.statusConexao || 'desconhecido',
      tipoApi: conversa.instancia?.tipoApi || (conversa.instanciaEvolution ? 'EVOLUTION' : conversa.instanciaUazapi ? 'UAZAPI' : conversa.instanciaMeta ? 'META' : undefined)
    } : undefined,
    instanciaUazapi: conversa.instanciaUazapi ? {
      id: conversa.instanciaUazapi.id,
      nome: conversa.instanciaUazapi.nome,
      statusConexao: conversa.instanciaUazapi.statusConexao
    } : undefined,
    instanciaMeta: conversa.instanciaMeta ? {
      id: conversa.instanciaMeta.id,
      nome: conversa.instanciaMeta.nome,
      statusConexao: conversa.instanciaMeta.statusConexao,
      tipoApi: 'META' as const
    } : undefined,
    instanciaMetaId: conversa.instanciaMetaId || conversa.instanciaMeta?.id || undefined,
    fila: conversa.fila ? {
      id: conversa.fila.id,
      nome: conversa.fila.nome
    } : undefined,
    contatoTags: conversa.contato?.contatoTags || [],
    ticketTags: conversa.tags || []
  };
};

export const formatUltimaInteracao = (conversa: {
  ultimaMensagem?: { timestamp?: Date | string | null } | null;
  dataAtualizacao?: Date | string | null;
}): string => {
  const raw = conversa.ultimaMensagem?.timestamp || conversa.dataAtualizacao;
  if (!raw) return '';
  const dataRef = raw instanceof Date ? raw : new Date(raw);
  if (Number.isNaN(dataRef.getTime())) return '';
  const diffMs = Date.now() - dataRef.getTime();
  const diffDays = Math.floor(diffMs / (24 * 60 * 60 * 1000));
  if (diffDays < 7) {
    return formatDistanceToNow(dataRef, { addSuffix: true, locale: ptBR });
  }
  return dataRef.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5001/api')?.replace(/\/api$/, '');

export const getFileUrl = (path?: string) => {
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path;
  let urlPath = path;
  if (!urlPath.startsWith('/')) urlPath = '/' + urlPath;
  if (!urlPath.startsWith('/uploads')) urlPath = '/uploads' + urlPath;
  return `${API_BASE_URL}${urlPath}`;
};

export const getInitials = (name: string | null | undefined = '') => {
  return (name ?? '')
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase() || 'C';
};
